import React, { Component } from 'react';

export default class view extends Component {
	constructor(props) {
		super(props)
		this.state = {
			CodeError: null,
			validResponse: ['4149', '4150', '4152', '4153', '4154', '4155', '4157', '4158', '4159', '4160', '4161', '4162']
		}
	}
	validateFormat = (data) => {
		//only allow numbers and limit length to 4
		//remove B from data if it exists
		var allValid = true
		console.log(data)
		for (let i in data) {
			console.log(data[i])
			if (isNaN(data[i]) && data[i] != 'B' && data[i] != 'b') {
				console.log("Invalid Character")
				allValid = false
			}
		}
		//check that data conatins only numbers and B
		if (allValid) {
			if (data && (data.length > 5)) {
				return this.props.data.EnteredDiagnosisCode;
			} else {
				return data.toUpperCase();
			}
		} else {
			return this.props.data.EnteredDiagnosisCode;
		}
	}

	checkDiagnosisCode = (e) => {
		console.log('here');
		//D8
		var next = ""
		var D13 = false;
		this.props.data.EnteredDiagnosisCode = this.props.data.EnteredDiagnosisCode.replace('B', '');
		if (this.props.data.Enteral.Inborn_Metabolic_Diagnosis || this.state.validResponse.includes(this.props.data.EnteredDiagnosisCode)) {
			//D9
			this.props.data.Inborn_Metabolic_Diagnosis = this.props.data.Enteral.Inborn_Metabolic_Diagnosis
			fetch(window.location.origin + window.location.pathname + 'checkimdiagnosiscode', {
				method: 'POST',
				headers: { "Content-Type": 'application/json' },
				body: JSON.stringify({ data: this.props.data })
			}).then(async (response) => {
				console.log("[DiagnosisCodeCheck] Response Status:", response.status);

				if (response.status === 200) {
					console.log("[DiagnosisCodeCheck] Status 200: proceeding to D12");
					next = "D12";
				} else {
					const dob = new Date(this.props.data.Enteral.PatientDOB);
					const ageMs = new Date().getTime() - dob.getTime();
					console.log("[DiagnosisCodeCheck] Non-200 response. Checking age (ms):", ageMs);

					if (ageMs > (31536000000 * 21)) {
						console.log("[DiagnosisCodeCheck] Age > 21");

						if (this.props.data.Enteral.InbornMetabolic === 'Y') {
							console.log("[DiagnosisCodeCheck] InbornMetabolic is Y");

							if (["4155", "4157"].includes(this.props.data.EnteredDiagnosisCode)) {
								console.log("[DiagnosisCodeCheck] DiagnosisCode is 4155 or 4157 → D12");
								next = "D12";
							} else {
								console.log("[DiagnosisCodeCheck] DiagnosisCode not 4155 or 4157 → D11");
								next = "D11";
							}
						} else {
							console.log("[DiagnosisCodeCheck] InbornMetabolic not Y → D12");
							next = "D12";
						}
					} else {
						console.log("[DiagnosisCodeCheck] Age <= 21 → D12");
						next = "D12";
					}
				}

				if (next === "D12") {
					console.log("[Navigation] Entering D12 path");

					this.props.data.EnteralCode = this.props.data.EnteredDiagnosisCode;
					console.log("[D12] Assigned EnteralCode:", this.props.data.EnteralCode);

					if (this.props.data.ModeOfAdmin === "T") {
						this.props.data.NDCCode = "0000B" + this.props.data.EnteralCode + "  ";
					} else {
						this.props.data.NDCCode = "0000B" + this.props.data.EnteralCode + "BO";
					}
					console.log("[D12] Generated NDCCode:", this.props.data.NDCCode);

					const dob = new Date(this.props.data.Enteral.PatientDOB);
					const ageMs = new Date().getTime() - dob.getTime();

					switch (this.props.data.EnteralCode) {
						case "4158":
							console.log("[D12] Case 4158. Age (ms):", ageMs, "DOB:", dob);
							if (ageMs > (31536000000 * 21)) {
								console.log("[D12] Age > 21 → navigating to D17");
								this.props.data.EnteralCode = "";
								this.props.navigate('D17');
							} else {
								console.log("[D12] Age <= 21 → continue to D13");
								D13 = true;
							}
							break;

						case "4159":
							console.log("[D12] Case 4159. Age (ms):", ageMs, "DOB:", dob);
							if (ageMs > (31536000000 * 21)) {
								console.log("[D12] Age > 21 → navigating to D18");
								this.props.data.EnteralCode = "";
								this.props.navigate('D18');
							} else {
								console.log("[D12] Age <= 21 → continue to D13");
								D13 = true;
							}
							break;

						case "4160":
						case "4161":
							console.log(`[D12] Case ${this.props.data.EnteralCode}. Age (ms):`, ageMs);
							if (ageMs > (31536000000 * 21)) {
								console.log("[D12] Age > 21 → navigating to D19");
								this.props.data.EnteralCode = "";
								this.props.navigate('D19');
							} else {
								D13 = true;
							}
							break;

						case "4162":
							console.log("[D12] Case 4162. InbornMetabolic:", this.props.data.Enteral.InbornMetabolic);
							if (this.props.data.Enteral.InbornMetabolic === "Y") {
								if (ageMs < (31536000000 * 21)) {
									console.log("[D12] Age < 21");
									if (ageMs < (31536000000 * 5)) {
										console.log("[D12] Age < 5 → navigating to D20");
										this.props.data.EnteralCode = "";
										this.props.navigate('D20');
									} else {
										console.log("[D12] Age between 5 and 21 → continue to D13");
										D13 = true;
									}
								} else {
									console.log("[D12] Age >= 21 → navigating to D19");
									this.props.data.EnteralCode = "";
									this.props.navigate('D19');
								}
							} else {
								console.log("[D12] InbornMetabolic false → navigating to D19");
								this.props.data.EnteralCode = "";
								this.props.navigate('D19');
							}
							break;

						case "4150":
						case "4157":
							console.log(`[D12] Case ${this.props.data.EnteralCode}. Age (ms):`, ageMs);
							if (ageMs > (31536000000 * 5)) {
								D13 = true;
							} else {
								console.log("[D12] Age <= 5 → navigating to D20");
								this.props.data.EnteralCode = "";
								this.props.navigate('D20');
							}
							break;

						default:
							console.log("[D12] Default case → continue to D13");
							D13 = true;
					}

					if (D13) {
						console.log("[D13] Checking additional conditions via D13Check API");

						fetch(window.location.origin + window.location.pathname + 'D13Check', {
							method: 'POST',
							headers: { "Content-Type": 'application/json' },
							body: JSON.stringify({ data: this.props.data })
						}).then(async (response) => {
							console.log("[D13Check] Response status:", response.status);

							if (response.status === 404) {
								console.log("[D13Check] Status 404");

								if (["4154", "4155", "4157", "4161", "4162"].includes(this.props.data.EnteralCode)) {
									console.log("[D13Check] DiagnosisCode triggers D21");
									this.props.navigate('D21');
								} else {
									console.log("[D13Check] DiagnosisCode triggers D22");
									this.props.navigate('D22');
								}
							} else {
								console.log("[D13Check] Status 200 → navigating to D25 with expiration date");
								this.props.data.Greatest_Expiration_Date = await response.text();
								console.log("[D13Check] Greatest Expiration Date:", this.props.data.Greatest_Expiration_Date);
								this.props.navigate('D25');
							}
						});
					}
				} else {
					console.log("[Navigation] Falling back to D11");
					this.props.navigate('D11');
				}
			});
		} else {
			//D8a
			this.setState({ CodeError: 'Invalid Response' })
		}
	}
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Enter the Enteral Procedure Code for the Enteral being dispensed:</p>
				<input type="text" value={this.props.data.EnteredDiagnosisCode} onChange={(e) => { this.props.setData('EnteredDiagnosisCode', this.validateFormat(e.currentTarget.value)) }} />

				<br />
				{this.state.CodeError ? <div className="error">{this.state.CodeError}</div> : ''}

				<div className="button" onClick={() => this.checkDiagnosisCode()}>Continue</div>
			</div>
		);
	}
}